import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

const RejectPreRegistrationModal = ({ isOpen, toggle, onSubmit }) => {

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      reason: "",
    },

    validationSchema: Yup.object({
      reason: Yup.string()
        .trim()
        .required("Le motif du rejet est obligatoire")
        .min(5, "Le motif doit contenir au moins 5 caractères"),
    }),

    onSubmit: (values) => {
      onSubmit(values.reason);
      validation.resetForm();
      toggle();
    },
  });

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        Motif du rejet
      </ModalHeader>

      <Form onSubmit={validation.handleSubmit}>
        <ModalBody>
          <FormGroup>
            <Label for="reason">Motif</Label>
            <Input
              id="reason"
              name="reason"
              type="textarea"
              rows="4"
              placeholder="Saisir le motif du rejet…"
              value={validation.values.reason}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              invalid={
                validation.touched.reason &&
                !!validation.errors.reason
              }
            />
            {validation.touched.reason && validation.errors.reason && (
              <FormFeedback>
                {validation.errors.reason}
              </FormFeedback>
            )}
          </FormGroup>
        </ModalBody>

        <ModalFooter>
          <Button
            type="button"
            color="secondary"
            onClick={toggle}
          >
            Annuler
          </Button>

          <Button
            type="submit"
            color="danger"
          >
            Confirmer le rejet
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default RejectPreRegistrationModal;
